import { getOrganizationAccessError, getOrganizationAccessMessage } from "./organization-access-errors";
import { ConvexError } from "convex/values";

function getMessageFromConvexData(data: unknown) {
  if (typeof data === "string" && data.trim().length > 0) {
    return data;
  }

  if (typeof data === "object" && data !== null && "message" in data) {
    const message = (data as { message?: unknown }).message;
    if (typeof message === "string" && message.trim().length > 0) {
      return message;
    }
  }

  return null;
}

function getConvexErrorDataMessage(error: unknown) {
  if (error instanceof ConvexError) {
    return getMessageFromConvexData(error.data);
  }

  if (typeof error === "object" && error !== null && "data" in error) {
    return getMessageFromConvexData((error as { data?: unknown }).data);
  }

  return null;
}

function getMessageFromRawConvexError(message: string) {
  const marker = "Uncaught ConvexError:";
  const markerIndex = message.indexOf(marker);
  if (markerIndex === -1) {
    return null;
  }

  const rawMessage = message.slice(markerIndex + marker.length).trim();
  return rawMessage.length > 0 ? rawMessage : null;
}

function isRawConvexRuntimeErrorMessage(message: string) {
  return message.includes("[CONVEX ");
}

export function getUserFacingErrorMessage(error: unknown, fallbackMessage: string) {
  const access = getOrganizationAccessError(error);
  if (access) return getOrganizationAccessMessage(access.state);
  const convexDataMessage = getConvexErrorDataMessage(error);
  if (convexDataMessage) {
    return convexDataMessage;
  }

  if (!(error instanceof Error)) {
    return fallbackMessage;
  }

  const message = error.message.trim();
  const rawConvexErrorMessage = getMessageFromRawConvexError(message);
  if (rawConvexErrorMessage) {
    return rawConvexErrorMessage;
  }

  if (!message || isRawConvexRuntimeErrorMessage(message)) {
    return fallbackMessage;
  }

  return message;
}
